import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const LogoutButton = () => {
  // const auth = useAuth();
  const navigate = useNavigate()

  const handleLogout = async () => {
    // auth.signoutRedirect()
    navigate('/logout')
  };

  return (
    <Button onClick={handleLogout} variant="contained" sx={{borderColor: 'white', color: "white"}}>
      Logout
    </Button>
  );
};

export default LogoutButton;

  // const logout = async () => {
  //   try {
  //     // Prima pulisci lo stato locale
  //     await auth.removeUser();
      
  //     // Pulisci completamente tutto il storage del browser
  //     localStorage.clear();
  //     sessionStorage.clear();
      
  //     // Rimuovi anche eventuali cookie di Cognito
  //     document.cookie.split(";").forEach(function(c) { 
  //       document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/"); 
  //     });
      
  //     const clientId = "6uqpa8c2rpued6kgt49js036d8";
  //     const logoutUri = "http://localhost:3000/";
  //     const cognitoDomain = "gksd-product-matching-app-login.auth.eu-south-1.amazoncognito.com";
      
  //     // Redirect a Cognito logout
  //     window.location.href = `https://${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(logoutUri)}`;
      
  //   } catch (error) {
  //     console.error('Errore durante il logout:', error);
      
  //     // In caso di errore, forza comunque la pulizia completa
  //     localStorage.clear();
  //     sessionStorage.clear();
  //     window.location.href = "http://localhost:3000/";
  //   }
  // };